import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-76f175b2"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "row-span-2 text-sm sm:text-base lg:text-sm xl:text-base pt-10" }
const _hoisted_2 = { class: "font-bold text-xl sm:text-4xl lg:text-xl xl:text-4xl" }
const _hoisted_3 = { class: "py-4 sm:py-10" }
const _hoisted_4 = { class: "py-4 sm:py-10 font-bold" }
const _hoisted_5 = { class: "row-span-2 mt-10 p-6 max-w-sm h-fit bg-white rounded-lg border border-gray-200 shadow-md dark:bg-gray-800 dark:border-gray-700" }
const _hoisted_6 = { class: "font-bold mb-3" }
const _hoisted_7 = ["src"]

import DiagnosticSection from '@/components/video-diagnostic/DiagnosticSection.vue'
import { useCheckPermissions } from '@/composables/video-diagnostic/useCheckPermissions'
import { Stage, Topic } from '@/types/enums/zoom-diagnostic.enum'
import { IUpdateTopic } from '@/types/interfaces/video-diagnostic.interface'
import { permissions } from '@/composables/video-diagnostic/useCheckPermissions'
import { watch, computed } from 'vue'
import UAParser from 'ua-parser-js'

interface CheckPermissionsEmits {
  (e: 'updateTopic', value: IUpdateTopic): void
  (e: 'nextStage', value: number): void
}


export default /*#__PURE__*/_defineComponent({
  __name: 'CheckPermissions',
  props: {
  stage: {
    type: Number,
    required: true,
  },
},
  emits: ["updateTopic", "nextStage"],
  setup(__props, { emit: __emit }) {

const props = __props

const emit = __emit

const allowPermissionImg = computed(() => {
  const userAgentParser = new UAParser()
  const userAgentInfo = userAgentParser.getResult()
  const browser = userAgentInfo.browser

  if (browser.name?.includes('Chrome')) {
    return require('../../assets/video-diagnostic/allow-permission-chrome.png')
  }
  if (browser.name?.includes('Firefox')) {
    return require('../../assets/video-diagnostic/allow-permission-firefox.png')
  }
  if (browser.name?.includes('Edge')) {
    return require('../../assets/video-diagnostic/allow-permission-edge.png')
  }
  if (browser.name?.includes('Safari')) {
    return require('../../assets/video-diagnostic/allow-permission-safari.png')
  }
  return require('../../assets/video-diagnostic/allow-permission-default.png')
})

watch(
  () => props.stage,
  (stage, prevStage) => {
    if (stage === Stage.CHECK_PERMISSIONS) {
      emit('updateTopic', { topic: Topic.DEVICE_SETUP, active: true })
    }
    if (prevStage === Stage.CHECK_PERMISSIONS && stage === Stage.GET_STARTED) {
      emit('updateTopic', { topic: Topic.DEVICE_SETUP, active: false })
    }
  },
)

const checkPermissionsEmit = async () => {
  try {
    await useCheckPermissions()
    permissions.value = true
    emit('nextStage', Stage.CAMERA_TEST)
    // setTimeout(() => {
    //   permissions.value = true
    //   emit('nextStage', Stage.CAMERA_TEST)
    // }, 500)
  } catch (err) {
    emit('nextStage', Stage.PERMISSION_ERROR)
    // setTimeout(() => {
    //   emit('nextStage', Stage.PERMISSION_ERROR)
    // }, 500)
  }
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(DiagnosticSection, {
    id: _unref(Stage).CHECK_PERMISSIONS,
    class: _normalizeClass(
      __props.stage === _unref(Stage).GET_STARTED
        ? 'opacity-0'
        : __props.stage === _unref(Stage).CHECK_PERMISSIONS || __props.stage === _unref(Stage).RESULTS
        ? 'block'
        : 'hidden md:block opacity-30 pointer-events-none'
    )
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("h1", _hoisted_2, _toDisplayString(_ctx.$t('zoom-diagnostic.check-permissions')), 1),
        _createElementVNode("p", _hoisted_3, _toDisplayString(_ctx.$t('zoom-diagnostic.check-permissions-detail')), 1),
        _createElementVNode("p", _hoisted_4, _toDisplayString(_ctx.$t('zoom-diagnostic.allow-permissions')), 1),
        _createElementVNode("button", {
          class: _normalizeClass([{ 'opacity-30 pointer-events-none': __props.stage === _unref(Stage).RESULTS }, "text-white border-2 rounded-md border-white py-2 px-4"]),
          type: "button",
          onClick: checkPermissionsEmit
        }, _toDisplayString(_ctx.$t('zoom-diagnostic.request-permissions-button')), 3)
      ]),
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("p", _hoisted_6, _toDisplayString(_ctx.$t('zoom-diagnostic.grant-permissions')), 1),
        _createElementVNode("img", {
          src: allowPermissionImg.value,
          alt: "allow permission img for globish zoom diagnostic"
        }, null, 8, _hoisted_7)
      ])
    ]),
    _: 1
  }, 8, ["id", "class"]))
}
}

})